<template>
    <div class="UserContact" :class="info?.current?'active':''">
        <div class="UserContact__in ">
            <a-avatar
                :src="user.avatar.src"
                :alt="user.avatar.alt"
                :title="user.avatar.title"
                :width="50"/>
            <div class="UserContact__info">
                <div>
                    <strong>{{ user.name }}</strong><span>{{ user.position }}</span>
                </div>
                <div>
                    {{ stats.date }}
                </div>
            </div>
            <div class="UserContact__time">{{ stats.time }}</div>
            <div class="UserContact__status" v-html="renderTick(stats.status)"></div>
        </div>
    </div>
</template>

<script>
// https://i.imgur.com/QUIIUwi.png reference

import {computed} from "vue";
import {AAvatar} from "../ui";

const STATUSES = {
    sent: 'sent',
    delivered: 'delivered',
    read: 'read',
}

export default {
    name: "UserContact",
    props: {
        info:{
          type: Object,
          default: {}
        },
        user: {
            type: Object,
            default: {
                avatar: '',
                name: '',
                position: ''

            }
        },
        stats: {
            type: Object,
            required: true,
            default: {
                time: '00:00',
                status: STATUSES.sent,
                date: '01 декабря 1970..'
            },
            validator(val) {
                return Object.keys(STATUSES).includes(val?.status)
            }
        }
    },
    components: {
        AAvatar,
    },
    setup(props) {
        const tick = (isActive = false) => {
            return `<svg width="13" height="10" viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg" fill="${isActive ? '#6367A7' : '#87929D'}">
                    <rect width="12" height="2" rx="1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 4.24219 9.89941)" />
                    <rect width="2" height="6" rx="1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 4.24219 9.89941)" />
                    </svg>
                    `
        }

        const renderTick = (status) => {
            switch (status) {
                case STATUSES.sent:
                    return tick()

                case STATUSES.delivered:
                    return tick() + tick()

                case STATUSES.read:
                    return tick(true) + tick(true)

                default:
                    return tick()
            }
        }

        return {
            renderTick
        }
    }
}
</script>

<style scoped lang="scss">

.UserContact {
    position: relative;
    width: 100%;
    padding: rem(23);
    background-color: #fff;
    border-top: 1px solid var(--c-gray-600);
    border-bottom: 1px solid var(--c-gray-600);
    margin-bottom: -1px;
    margin-top: -1px;
    cursor: pointer;

    &__in {
        display: flex;
        gap: rem(12);
    }

    &__time {
        position: absolute;
        top: rem(5);
        right: rem(10);
        color: var(--c-gray-600);
        font-weight: 400;
        font-size: rem(14);
        line-height: rem(34);
    }

    &__status {
        position: absolute;
        bottom: rem(15);
        right: rem(15);

        ::v-deep svg {
            margin-left: rem(-10);
        }
    }

    &__info {
        display: flex;
        flex-direction: column;

        strong {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
        }
    }
}
.UserContact.active {
background: #d4fffd;
}
</style>